import { Outlet } from 'react-router-dom';

const LoginLayout = () => {
  return <Outlet />;
};

export default LoginLayout;
